import React, { Suspense, useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { CreateFlow } from './pages/CreateFlow';
import { Dashboard } from './pages/Dashboard';
import { TakeChallenge } from './pages/TakeChallenge';
import { ChallengeResult } from './pages/ChallengeResult';
import { ErrorBoundary } from './components/ErrorBoundary';

// Lazy load the SDK Provider to catch module-level initialization errors
const SafeQuestProvider = React.lazy(() => import('./components/SafeQuestProvider'));

const AppRoutes = () => (
  <HashRouter>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/create" element={<CreateFlow />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/challenge/:data" element={<TakeChallenge />} />
      <Route path="/result" element={<ChallengeResult />} />
    </Routes>
  </HashRouter>
);

function App() {
  useEffect(() => {
    console.log("%c DO YOU KNOW ME? %c v1.1.5 %c System Online ", 
      "background:#0094f7; color:white; font-weight:bold; padding: 2px 4px; border-radius: 4px 0 0 4px;",
      "background:#d2ff02; color:#012b58; font-weight:bold; padding: 2px 4px;",
      "background:#1e293b; color:#94a3b8; padding: 2px 4px; border-radius: 0 4px 4px 0;"
    );
  }, []);

  return (
    <ErrorBoundary fallback={<AppRoutes />}>
      <Suspense fallback={<AppRoutes />}>
        <SafeQuestProvider 
          apiKey="dummy-api-key" 
          entityId="dummy-entity-id"
          apiType="PRODUCTION"
        >
          <AppRoutes />
        </SafeQuestProvider>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;